import React from 'react';
import { Box, Button, VStack, Text } from '@chakra-ui/react';
import { SectionContainer } from '../SectionContainer';
import { ScrollReveal } from '../ScrollReveal';
import { trackEvent } from '../../utils/analytics';
import { useJoin } from '../../context/JoinContext';

export default function VisionSection() {

  return (
    <SectionContainer
      bg="bg.800"
      id="vision"
      aria-labelledby="vision-heading"
      py={{ base: '80px', md: '140px' }}
    >
      <ScrollReveal>
        <VStack spacing={8} align="center" textAlign="center" maxW="820px" mx="auto">
          {/* Kicker */}
          <Text
            fontFamily="'JetBrains Mono', monospace"
            fontWeight="500"
            fontSize="0.75rem"
            textTransform="uppercase"
            letterSpacing="1.5px"
            color="brand.300"
          >
            The Vision
          </Text>

          {/* Headline */}
          <Text
            id="vision-heading"
            as="h2"
            fontFamily="'Space Grotesk', sans-serif"
            fontWeight="700"
            fontSize={{ base: 'clamp(1.8rem, 5.5vw, 2.2rem)', md: 'clamp(2.2rem, 4vw, 3rem)' }}
            letterSpacing="-0.025em"
            color="text.primary"
            lineHeight="1.15"
          >
            We're not building an AI product.{' '}
            <Box as="span" color="brand.400">
              We're building AI that builds organizations.
            </Box>
          </Text>

          {/* Body */}
          <Text
            fontSize={{ base: '1.05rem', md: '1.2rem' }}
            color="text.muted"
            lineHeight="1.7"
            maxW="640px"
          >
            From a single instruction to a complete, self-operating company — designing,
            staffing, and improving itself with every task.
          </Text>

          {/* Signature */}
          <Text
            fontFamily="'Space Grotesk', sans-serif"
            fontWeight="700"
            fontSize={{ base: '1.5rem', md: '2rem' }}
            color="brand.400"
            letterSpacing="-0.02em"
            fontStyle="italic"
          >
            Creation that creates.
          </Text>
        </VStack>
      </ScrollReveal>
    </SectionContainer>
  );
}
